import axios from 'axios';
import sysConfig from "@/config";
import { Message } from 'element-ui';
// import { Message,ElMessageBox,ElMessage } from 'element-plus';
axios.defaults.baseURL = ''


// loading
class loadingInstance {
	constructor(loading = null,count = 0) {
		this.loading = loading; // 实例对象
		this.loadingCount = count; // loading次数
	}
	showLoading(config) { // 监测url带有page或list, 显示loadIng
		const urlSplitArr = (config.url || '').split('/')
		const [urlFlag = ''] = [...urlSplitArr].reverse()
		if (this.loadingCount === 0) {
			if (urlFlag === 'page') {
				// this.loading = ElLoading.service({
				// 	lock: true,
				// 	text: '加载中'
				// });
			}
		}
		this.loadingCount++
	}
	hideLoading() { // 隐藏loading
		this.loadingCount--
		if (this.loadingCount === 0) {
			// this.loading.close()
			this.loading = null
		}
	}
}

const loading = new loadingInstance()



// HTTP request 拦截器
axios.interceptors.request.use(
	(config) => {
		loading.showLoading(config)
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

//FIX 多个API同时401时疯狂弹窗BUG
let MessageBox_401_show = false

// HTTP response 拦截器
axios.interceptors.response.use(
	(response) => {

		response.data.code === 0 && loading.hideLoading()
		if (response.data.code === sysConfig.RESULT_CODE) {
            return response;
		}  else {
			Message.closeAll()
            Message({
                duration: 1000,
                type: 'warning',
                message: response.data.msg
            });
		}
		return response;
	},
	(error) => {
		if (error.response) {
			loading.hideLoading()
			if (error.response.status == 404) {
				Message.error({
					title: '请求错误',
					message: "Status:404，正在请求不存在的服务器记录！"
				});
			} else if (error.response.status == 403) {
				Message.error({
					title: '鉴权失败',
					message: error.response.data.msg || "Status:403，鉴权失败！"
				});
			} else if (error.response.status == 500) {
				Message.error({
					title: '请求错误',
					message: error.response.data.msg || "Status:500，服务器发生错误！"
				});
			} else if (error.response.status == 401) {
				if (!MessageBox_401_show) {
					MessageBox_401_show = true
					Message.error({
						title: '请求错误',
						message: error.response.data.msg || "Status:401，无权限访问！"
					});
				}
			} else {
				Message.error({
					title: '请求错误',
					message: error.msg || `Status:${error.response.status}，未知错误！`
				});
			}
		} else {
			loading.hideLoading()
			Message.error({
				title: '请求错误',
				message: "请求服务器无响应！"
			});
		}
		return Promise.reject(error.response);
	}
);

var http = {

	/** get 请求
	 * @param  {string} url 接口地址
	 * @param  {object} params 请求参数
	 * @param  {object} config 参数
	 */
	get: function (url,params = {},config = {}) {
		return new Promise((resolve,reject) => {
			axios({
				method: 'get',
				url: url,
				params: params,
				...config
			}).then((response) => {
				if (config.responseType === 'blob') {
					resolve(response);
				} else {
					resolve(response.data);
				}
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** post 请求
	 * @param  {string} url 接口地址
	 * @param  {object} data 请求参数
	 * @param  {object} config 参数
	 */
	post: function (url = '',data = {},config = {}) {
		return new Promise((resolve) => {

			const arr = url.split('/').reverse()
			const [urlKey = ''] = [...arr]
			if (!Cookies.get(url)) {
				const expires = new Date(new Date() * 1 + 3 * 1000)
				// add','edit','del','update'防止重复提交
				const lockArr = ['add','edit','del','update']
				if (lockArr.includes(urlKey)) {
					Cookies.set(url,true,{ expires })
				}
				axios({
					method: 'post',
					url: url,
					data: data,
					...config
				}).then((response) => {
					if (config.responseType === 'blob') {
						resolve(response);
					} else {
						resolve(response.data);
					}
				}).catch((error) => {
					resolve(error);
				})
			}
		})
	},

	/** put 请求
	 * @param  {string} url 接口地址
	 * @param  {object} data 请求参数
	 * @param  {object} config 参数
	 */
	put: function (url,data = {},config = {}) {
		return new Promise((resolve) => {
			axios({
				method: 'put',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				resolve(error);
			})
		})
	},

	/** patch 请求
	 * @param  {string} url 接口地址
	 * @param  {object} data 请求参数
	 * @param  {object} config 参数
	 */
	patch: function (url,data = {},config = {}) {
		return new Promise((resolve,reject) => {
			axios({
				method: 'patch',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** delete 请求
	 * @param  {string} url 接口地址
	 * @param  {object} data 请求参数
	 * @param  {object} config 参数
	 */
	delete: function (url,data = {},config = {}) {
		return new Promise((resolve,reject) => {
			axios({
				method: 'delete',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** jsonp 请求
	 * @param  {string} url 接口地址
	 * @param  {string} name JSONP回调函数名称
	 */
	jsonp: function (url,name = 'jsonp') {
		return new Promise((resolve) => {
			var script = document.createElement('script')
			var _id = `jsonp${Math.ceil(Math.random() * 1000000)}`
			script.id = _id
			script.type = 'text/javascript'
			script.src = url
			window[name] = (response) => {
				resolve(response)
				document.getElementsByTagName('head')[0].removeChild(script)
				try {
					delete window[name];
				} catch (e) {
					window[name] = undefined;
				}
			}
			document.getElementsByTagName('head')[0].appendChild(script)
		})
	}
}

export default http;
